module.exports = __webpack_public_path__ + "fonts/Manrope-Medium.36bd0514.ttf";